import type { CharacterState } from "@/data/types";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export function StepNameBackground({
  state,
  onChange,
}: {
  state: CharacterState;
  onChange: (s: CharacterState) => void;
}) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold mb-1">Name & Background</h2>
        <p className="text-muted-foreground text-sm">Who is your warlock?</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="char-name">Character Name *</Label>
        <Input
          id="char-name"
          placeholder="Enter your character's name"
          value={state.name}
          onChange={(e) => onChange({ ...state, name: e.target.value })}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="char-bg">Backstory / Background (optional)</Label>
        <Textarea
          id="char-bg"
          placeholder="Describe your character's history, motivations, and personality..."
          value={state.background}
          onChange={(e) => onChange({ ...state, background: e.target.value })}
          rows={6}
        />
      </div>
    </div>
  );
}
